<!-- TODO: remove below condition - currently copilot feature is supported only in page workspace  -->
<div class="copilot-container" *ngIf="wmsWorkspaceManager.activeWSCategory === 'PAGE'">
    <div *ngIf="copilotService.currentScreen === 'copilot'">
        <button class="copilot-button" (click)="onCopilotBtnClick()" (mouseenter)="onMouseHover()"
            (mouseleave)="onMouseLeave()">
            <img [src]="('assets/images/copilot/copilot-colored-glitter.png' | versionManager)"   alt="Copilot Icon" class="copilot-icon" />
            <span>{{ displayText }}</span>
        </button>
    </div>
</div>

<wms-dialog id="copilot-modal" [customClasses]="customClasses" [content]="copilotModalDialog" [closeOnEscape]="false">
</wms-dialog>
<ng-template #copilotModalDialog>
    <wms-copilot-modal-content (dialogSize)="setCustomClass($event)"></wms-copilot-modal-content>
</ng-template>